import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgressUserAwardsList extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
        this.industryTaxonParentId = '2a37d4d1-00a5-47d0-bc07-b90a9b8b2052';
        this.awardTaxonParentId = 'cbe81580-509b-42a7-85db-c2736ab49c54';
        this.countryTaxonParentId = '747f50af-d826-4b19-8eb9-3c8880a8ef1b';
        this.yearTaxonParentId = 'bcb8fbc4-83bf-463c-9c27-0ebe6d51c951';
        this.monthTaxonParentId = '44758699-4324-408a-8400-6190310374c1';
        this.projectOfTheMonthTaxonId = 'ae08dcbc-a2ed-4951-becb-5cb1ab9c9260';
        this.practitionerOfTheYearTaxonId = '17ec98a9-02e5-472e-b69e-6862e76493a4';
        this.websiteOfTheYearTaxonId = '0ed015d0-836d-453c-afec-ea03f5c4f8c3';
    }

    getItemHtml(item) {
        let html = '';
        if (item && item.taxonomyNavigationProperty){
            let industryTitles = item.taxonomyNavigationProperty
            .filter(taxon => taxon.ParentId == this.industryTaxonParentId)
            .map(taxon => taxon.Title)
            .join(', ');
            let awardTitle = item.taxonomyNavigationProperty.filter(taxon => taxon.ParentId == this.awardTaxonParentId)[0].Title;
            let awardId = item.taxonomyNavigationProperty.filter(taxon => taxon.ParentId == this.awardTaxonParentId)[0].Id;
            let countryTitle = item.taxonomyNavigationProperty.filter(taxon => taxon.ParentId == this.countryTaxonParentId)[0].Title;
            let year = item.taxonomyNavigationProperty.filter(taxon => taxon.ParentId == this.yearTaxonParentId)[0].Title;
            let labelText = '';
            let labelClass = '';

            html = '<div class="col-12 -mb3 -m-half -s-full"><div class="Elevated -full -pr -bg-white -br2">';
            if(awardId == this.projectOfTheMonthTaxonId){
                labelClass = '10';
                labelText = `${awardTitle}</h5>`;
            }
            else if(awardId == this.practitionerOfTheYearTaxonId){
                labelClass = '4';
                labelText = `${year} ${awardTitle}</h5>`;
            }
            else if(awardId == this.websiteOfTheYearTaxonId){
                labelClass = '9';
                labelText = `${year} ${awardTitle}</h5>`;
            }
            html += `
                    <div class="ResourceItem">
                        <div class="ResourceItem-image Section-bg">
                            <img src="${item.Screenshot.Url}" alt="award pohoto thumbnail"/>
                            <p class="ResourceLabel -mb0 -pa -l0 -b0 -z1 ResourceLabel--${labelClass}">${labelText}</p>
                        </div>
                        <div class="ResourceItem-info">
                            <a href="/sitefinity-cms/user-awards/${item.UrlName}" class="-accento-0 -mb1 -ps HoverBox HoverBox--over ResourceItem-title h4">${this.encodeHtml(item.Title)}</a>
                            <div class="-ff-base -fs15">Industry: ${industryTitles}</div>
                            <div class="-ff-base -fs15">Country: ${countryTitle}</div>
                        </div>
                    </div>
                </div>
            </div>`;
        }

        return html;
    }
}
